export default "__VITE_ASSET__uf$aP8mU__"